import { memo } from 'react'

import { useTranslation } from 'react-i18next'

interface ILoadMoreButtonProps {
    onClick: any
}

export const LoadMoreButton = memo(({ onClick }: ILoadMoreButtonProps) => {
    const { t } = useTranslation()
    return (
        <button
            onClick={() => onClick()}
            className='catalog__products-button button-more'
        >
            {t('loadMore')}
        </button>
    )
})
